export interface SubscriptionData {
    subId: string,
    sfId: string,
    product: string;
    tier: string;
    subType: SubscriptionSubType;
    resources: SubscriptionResource;
    startDate: string;
    endDate: string;
    status: boolean;
    selected?: boolean;
    userSub?: boolean;
    maxDownloads?: number;
    downloadsCount?: number;
    downloads?: string[];
    lookerGroupIds?: number[];
    allowDownloads?: boolean;
    rmmViewer?: boolean;
    rmmExplore?: boolean;
    rmmDownload?: boolean;
    rmmSave?: boolean;
    prismViewer?: boolean;
    prismExplore?: boolean;
    prismDownload?: boolean;
    prismSave?: boolean;
    reportsNews?: string;
    reportsCore?: string;
    reportsBrandCaseStudies?: string;
    reportsRetailerCaseStudies?: string;
    reportsDigitalRadar?: string;
    isTrial?: boolean;
}

export interface SubscriptionSubType {
    tier: string;
    seats: number;
    used: number;
}

export interface SubscriptionResource {
    accessType: string;
    access: ResourceAccess,
}

export interface ResourceAccess {
    RMM: {
        lookerGroupId: number[];
    },
    Reports: SubscriptionResourceAccessReport[]
}

export interface SubscriptionResourceAccessReport {
    code: string;
    group: string;
    access: string;
}

type Partial<T> = { [p in keyof T]?: T[p]; };

export type PartialSubsData = Partial<SubscriptionData>;
